package app.nestbridge.feature.home.presentation

import androidx.compose.runtime.Composable
import app.nestbridge.feature.home.screen.HomeEvent
import app.nestbridge.feature.home.screen.HomeScreen
import app.nestbridge.feature.home.screen.HomeState
import com.slack.circuit.codegen.annotations.CircuitInject
import com.slack.circuit.runtime.presenter.Presenter
import me.tatarka.inject.annotations.Inject
import software.amazon.lastmile.kotlin.inject.anvil.AppScope

@CircuitInject(
    screen = HomeScreen::class,
    scope = AppScope::class,
)
class HomePresenter @Inject constructor() : Presenter<HomeState> {

    @Composable
    override fun present(): HomeState {
        return HomeState(
            eventSink = { _: HomeEvent ->
                // No-op for now.
            },
        )
    }
}
